var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMergeRefs } from '@floating-ui/react';
import { useCallback, useEffect, useRef, useState, } from 'react';
import { createPortal } from 'react-dom';
import { Box } from '../../../Box';
import { DatePickerProvider } from '../context/DatePickerProvider';
import { DatePickerTestIdFactory } from '../interactions';
import { Calendar } from './Calendar';
import { CalendarHeader } from './CalendarHeader';
import { DateInput } from './DateInput';
import styles from '../DatePicker.module.css';
export const StaticDatePicker = ({ ref: forwardedRef, staticContainer, ...props }) => {
    _react_refresh_temp_2();
    const { 'data-testid': testId, id, max, min, onChange, value, wordings, } = props;
    const [isOpen, setIsOpen] = useState(false);
    // Wraps the input so we can tell apart clicks on the trigger (input +
    // calendar button) from genuine outside clicks.
    const staticTriggerRef = useRef(null);
    // Direct handle on the input to return focus to it on keyboard dismissal.
    const inputRef = useRef(null);
    const mergedRef = useMergeRefs([forwardedRef, inputRef]);
    const onOpen = useCallback(() => setIsOpen(true), []);
    // Wired to the calendar's setIsCalendarOpen, which is invoked for keyboard
    // dismissals (Escape / Alt+ArrowUp); restore focus to the input on close.
    const setIsCalendarOpen = useCallback((next) => {
        setIsOpen(next);
        if (next === false) {
            inputRef.current?.focus();
        }
    }, []);
    // Hide the calendar on outside click. Outside clicks use this raw setter so
    // they don't steal focus back to the input.
    useEffect(() => {
        if (!isOpen) {
            return;
        }
        const onOutsidePointerDown = (event) => {
            const target = event.target;
            if (staticTriggerRef.current?.contains(target) ||
                staticContainer?.contains(target)) {
                return;
            }
            setIsOpen(false);
        };
        document.addEventListener('mousedown', onOutsidePointerDown);
        return () => {
            document.removeEventListener('mousedown', onOutsidePointerDown);
        };
    }, [isOpen, staticContainer]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.StaticTrigger, ref: staticTriggerRef, children: _jsx(DateInput, { ...props, calendarButtonAriaLabel: wordings.calendarButtonAriaLabel, isPopupOpen: isOpen, onIconClick: onOpen, onKeyboardOpen: onOpen, onPointerOpen: onOpen, ref: mergedRef, value: value }) }), isOpen &&
                staticContainer &&
                createPortal(_jsx("dialog", { "aria-labelledby": `${id}-calendar-header`, className: styles.DialogStatic, "data-testid": DatePickerTestIdFactory.getDatePickerDialogTestId(testId), id: `${id}-dialog`, open: true, children: _jsx(DatePickerProvider, { closeOnSelect: false, id: id, initialValue: value, max: max, min: min, onChange: onChange, setIsCalendarOpen: setIsCalendarOpen, value: value, wordings: wordings, children: _jsxs(Box, { gap: "s", isFullWidth: true, orientation: "vertical", padding: "s", children: [_jsx(CalendarHeader, { "data-testid": testId }), _jsx(Calendar, { "data-testid": testId })] }) }) }), staticContainer)] }));
};
_react_refresh_temp_1 = StaticDatePicker;
$RefreshReg$(_react_refresh_temp_1, "StaticDatePicker");
_react_refresh_temp_2(StaticDatePicker, "ZGHWrev+bWJhO0PGDmiX2qYhKFg=", false, () => [useMergeRefs]);
